<template>
  <div class="contentHome">
    <div class="centerPage">
      <meta name="referrer" content="no-referrer">
      <div class="search-box">
        <router-link class="title " to="/news">新闻资讯</router-link>
        <router-link class="title" to="/study">每日研究</router-link>
        <router-link class="title" to="/publicWelfare">亦笙公益</router-link>
        <span class="title active">地区资源</span>
        <el-input size="mini" v-model="search" class="search" suffix-icon="el-icon-search"   placeholder="请输入城市名称"
                  @change="getData"></el-input>
      </div>
      <div style="align-items: normal" class="flex">
        <div class="left">
          <div class="type" v-if="cities.length!=0">
            <p v-for="(obj,index) in cities" :key="obj.id"
               :class="active==index?'activeClass':''"
               @click="change(index,obj.id)">
              <span>{{ obj.cnName }}</span>
              <img src="../../assets/img/activeImg.png" alt="" width="17" v-show="active==index">
            </p>
          </div>
        </div>
        <div class="right" v-if="cities.length!=0">
          <div :style="'backgroundImage: url('+cities[active].imgPath+')'" class="img imgR">
            <div class="titArea"><h1><em>“{{ cities[active].cnName }}”</em><br>{{ cities[active].title }}</h1></div>
          </div>
          <div class="organ-block">
            <div class="organ-type">
              <span :active="organType==1" @click="changeOrgan(1)">著名医院推荐</span>
              <span :active="organType==2" @click="changeOrgan(2)">社区组织推荐</span>
              <span :active="organType==3" @click="changeOrgan(3)">其他机构</span>
            </div>

            <div class="organ-body" v-if="organType==1">
              <div v-if="hospitals.length===0" class="tips"><img src="../../assets/img/empty_tips.png" alt=""></div>
              <div class="organ-list" v-for="item in hospitals" :key="item.id">
                <h3>{{ item.title }}<span>{{ item.subTitle }}</span></h3>
                <p class="content">{{ item.briefDesc }}</p>
                <p v-if="item.linkUrl">链接：<a :href="item.linkUrl" target="_blank">{{ item.linkUrl }}</a></p>
              </div>
            </div>

            <div class="organ-body" v-if="organType==2">
              <div v-if="communities.length===0" class="tips"><img src="../../assets/img/empty_tips.png" alt=""></div>
              <div class="organ-list" v-for="item in communities" :key="item.id">
                <h3>{{ item.title }}<span>{{ item.subTitle }}</span></h3>
                <p class="content">{{ item.briefDesc }}</p>
                <p v-if="item.linkUrl">链接：<a :href="item.linkUrl" target="_blank">{{ item.linkUrl }}</a></p>
              </div>
            </div>

            <div class="organ-body" v-if="organType==3">
              <div v-if="others.length===0" class="tips"><img src="../../assets/img/empty_tips.png" alt=""></div>
              <div class="organ-list" v-for="item in others" :key="item.id">
                <h3>{{ item.title }}<span>{{ item.subTitle }}</span></h3>
                <p class="content">{{ item.briefDesc }}</p>
                <p v-if="item.linkUrl">链接：<a :href="item.linkUrl" target="_blank">{{ item.linkUrl }}</a></p>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import base from '@/api/common';

export default {
  name: "regionalResources",
  data() {
    return {
      active: 0,
      regional: [],
      search: '',
      cities: [{}],

      organType: 1,
      hospitals: [],
      communities: [],
      others: []
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.$ajax.get(base.api.area.list, {params: {name: this.search}}).then((res) => {
        if (res.data.status === 'success') {
          this.cities = res.data.list;
          if (res.data.list && res.data.list.length > 0) {
            this.change(0, res.data.list[0].id);
          }
        }
      })
    },
    change(index, cityId) {
      this.active = index;
      this.organType = 1; // 恢复默认第一个
      // 清空list
      this.hospitals.length = 0;
      this.communities.length = 0;
      this.others.length = 0;
      this.$ajax.get(base.api.area.item.replace("{id}", cityId)).then((res) => {
        if (res.data.status === 'success') {
          let hos = [], com = [], oth = [];
          $(res.data.list).each((i, o) => {
            if (o.type && o.type == 1) {
              hos.push(o);
              return true;
            }
            if (o.type && o.type == 2) {
              com.push(o);
              return true;
            }
            if (o.type && o.type == 3) {
              oth.push(o);
              return true;
            }
          });
          this.hospitals = hos;
          this.communities = com;
          this.others = oth;
        }
      });
    },
    changeOrgan(organType) {
      this.organType = organType;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/regionalResources.scss";
</style>
